import { render, staticRenderFns } from "./ChangeWidget.vue?vue&type=template&id=6a01da95&"
import script from "./ChangeWidget.vue?vue&type=script&lang=js&"
export * from "./ChangeWidget.vue?vue&type=script&lang=js&"
import style0 from "./ChangeWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports